import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class PaymentDetailService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async update(payment_detail) {
    const { data } = await this.httpClient.patch(
      `/agent/api/payment_details/${payment_detail.id}`,
      {
        payment_detail,
      }
    )
    const updatedPaymentDetail = this.serializer.parseResourceData(
      data.payment_detail,
      data.payment_detail.data
    )

    return { paymentDetail: updatedPaymentDetail, flush: data.flush }
  }

  public async export() {
    const { data } = await this.httpClient.post('/agent/api/payment_details/export')
    return { flush: data.flush }
  }
}

export default PaymentDetailService
